var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVip = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95678 8.11273C5.80594 8.02907 5.62263 8.02907 5.47179 8.11273L3.18632 9.38018C2.80293 9.5928 2.35101 9.24419 2.45934 8.81938L3.03214 6.57305C3.08075 6.38243 3.01307 6.18103 2.85921 6.05845L0.992998 4.5716C0.63795 4.28873 0.813214 3.71724 1.26581 3.68205L3.81325 3.48399C3.99325 3.46999 4.15173 3.36004 4.22787 3.19633L5.26091 0.974913C5.44021 0.589362 5.98836 0.589362 6.16766 0.974913L7.20071 3.19633C7.27684 3.36004 7.43532 3.46999 7.61532 3.48399L10.1628 3.68205C10.6154 3.71724 10.7906 4.28873 10.4356 4.5716L8.56936 6.05845C8.41551 6.18103 8.34782 6.38243 8.39643 6.57305L8.96924 8.81938C9.07756 9.24419 8.62564 9.5928 8.24225 9.38018L5.95678 8.11273Z",
    fill: "#8C8C8C"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVip, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vip.5cf73c1d.svg";
export { ForwardRef as ReactComponent };